import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpInterceptorService } from '@core/interceptors/http-interceptor.service';
import { CompanyCustomizationsService } from '@core/services/customization/customizations.service';
import { ErrorDialogModule } from '@shared/modules/dialogs/error-dialog/error-dialog.module';
import { SuccessDialogModule } from '@shared/modules/dialogs/success-dialog/success-dialog.module';
import { LoaderInterceptor } from '@shared/modules/loader/loader.interceptor';
import { LoaderModule } from '@shared/modules/loader/loader.module';

import { FONT_COLOR_CONTRAST } from '@core/injection-tokens';
import { FaIconService } from '@core/services/faicon.service';
import { AppHostService } from '@core/services/host.service';
import * as fontColorContrast from 'font-color-contrast';
import { initializeApp } from './app-initializer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslocoRootModule } from './transloco-root.module';
import { LimitReachedDialogModule } from '@shared/modules/dialogs/limit-reached-dialog/limit-reached-dialog.module';
import { ViewAsBannerComponent } from '@shared/components/view-as-banner/view-as-banner.component';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ErrorDialogModule,
    LimitReachedDialogModule,
    SuccessDialogModule,
    LoaderModule,
    TranslocoRootModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatSnackBarModule,
    ViewAsBannerComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppHostService, CompanyCustomizationsService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: FONT_COLOR_CONTRAST, useValue: fontColorContrast.default },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
  constructor(iconService: FaIconService) {
    // Add an icon to the library for convenient access in other components
    iconService.setIcons();
  }
}
